/**
 * @file _view/_scroll-header.js
 */
(function($) {
	'use strict';

	/**
	 * @namespace ScrollHeader
	 * @constructor
	 * @classdesc スクロール量の計測
	 * @param {Object} $e -対象となる jQuery オブジェクト
	 */
	 var ScrollHeader = function ($e) {
	 	this._$e = $e;
	 	//$(window).on('load resize', this.adjustPadding.bind(this));
	 };


	/**
	 * @memberOf ScrollHeader
	 * @const {}
	 */
	ScrollHeader._classname = 'ScrollHeader';

	ScrollHeader.prototype.adjustPadding = function() {
		var headerHeight = this._$e.outerHeight();
		var PADDINGTOP = headerHeight;
		$('body').css({
			'padding-top': PADDINGTOP
		});
	};



	module.exports = ScrollHeader;
})(jQuery);